import Section from "../section";
import Entrees from "./food/entrees";
import Appetizers from "./food/appetizers";
import Dessert from "./food/dessert";

class Food extends Section {

  constructor(calculator) {
    super(calculator)

    // 20% service fee for all food and beverage
    this.fee = 0.2;

    //parts
    this.parts = [
      new Appetizers(this),
      new Entrees(this),
      new Dessert(this),
    ]

    console.log(this.parts)

  }

}

export default Food




// WEBPACK FOOTER //
// ./scripts/catcalc/sections/food.js